/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { AppError } from './AppError';

export class DroppedServiceRequestError extends AppError {
    private static TAG: string = 'DroppedServiceRequestError';

    constructor() {
        super(DroppedServiceRequestError.TAG, 'The service request has been dropped.');
    }
}
